<template>
    <edit-dialog title="新增租户" :show="show" @close="onClose" width="500px">
        <el-form :model="modelData" label-width="100px" :rules="validRules" ref="frm">
            <el-form-item prop="TenantName" label="租户名称">
                <el-input v-model="modelData.TenantName" class="inputText"></el-input>
            </el-form-item>
            <el-form-item prop="TenantNickName" label="租户简称">
                <el-input v-model="modelData.TenantNickName" class="inputText"></el-input>
            </el-form-item>
            <el-form-item prop="TenantType" label="租户类型">
                <el-select v-model="modelData.TenantType">
                    <el-option label="客流租户" :value="1"></el-option>
                    <el-option label="商场租户" :value="2"></el-option>
                    <el-option label="公交租户" :value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="UserCode" label="管理员账号">
                <el-input v-model="modelData.UserCode" class="inputText"></el-input>
            </el-form-item>
            <el-form-item prop="UserName" label="管理员名称">
                <el-input v-model="modelData.UserName" class="inputText"></el-input>
            </el-form-item>
            <el-form-item prop="DBName" label="数据库">
                <el-input v-model="modelData.DBName" v-if="isNew" class="inputText"></el-input>
                <el-select v-model="modelData.DBID" v-if="!isNew" @change="changeDB(item)">
                    <el-option v-for="item in dbList" :key="item" :label="item.DBName" :value="item.DBID"> </el-option>
                </el-select>
                <el-checkbox v-model="isNew" style="margin-left: 10px">新建</el-checkbox>
            </el-form-item>
        </el-form>
        <template v-slot:button>
            <el-button type="success" @click="saveData"> 保存 </el-button>
            <el-button type="info" @click="onClose"> 取消 </el-button>
        </template>
    </edit-dialog>
</template>

<script>
export default {
    components: {},
    name: "AddTenant",
    data() {
        return {
            isNew: false,
            dbList: [],
            modelData: {
                TenantID: "",
                TenantName: "",
                TenantNickName: "",
                TenantType: "",
                UserCode: "",
                UserName: "管理员",
                DBID: "",
                DBName: "",
            },
            validRules: {
                TenantName: [
                    {
                        required: true,
                        message: "请填写租户名称",
                        trigger: "blur",
                    },
                ],
                UserCode: [
                    {
                        required: true,
                        message: "请填写管理员账号",
                        trigger: "blur",
                    },
                ],
                DBName: [
                    {
                        required: true,
                        message: "请填写数据库名称",
                        trigger: "blur",
                    },
                ],
                TenantType: [
                    {
                        required: true,
                        message: "请选择租户类型",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    created() {
        this.getDBList();
    },
    props: {
        show: { type: Boolean, default: false },
    },
    methods: {
        changeDB(item) {
            this.modelData.DBName = item.DBName;
        },
        getDBList() {
            this.$ajax.post("Platform/GetDBs", {}).then((res) => {
                this.dbList = res.Data;
                if (this.dbList.length > 0) {
                    this.modelData.DBID = this.dbList[0].DBID;
                    this.modelData.DBName = this.dbList[0].DBName;
                }
            });
        },
        onClose() {
            this.$emit("close");
        },
        saveData() {
            this.$refs.frm.validate((r) => {
                if (r) {
                    this.$emit("save", this.modelData);
                } else {
                    return false;
                }
            });
        },
    },
};
</script>
<style scoped>
.inputText {
    width: 220px;
}
</style>
